import { render, staticRenderFns } from "./PxAutocompleteGrade.vue?vue&type=template&id=0798cb95"
import script from "./PxAutocompleteGrade.vue?vue&type=script&lang=js"
export * from "./PxAutocompleteGrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports